/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Invalid_FormatInputs */

const en_issue_invalid_format = /** @type {(inputs: Issue_Invalid_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is not in the format of its column`)
};

/**
* | output |
* | --- |
* | "is not in the format of its column" |
*
* @param {Issue_Invalid_FormatInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_invalid_format = /** @type {((inputs?: Issue_Invalid_FormatInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Invalid_FormatInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_invalid_format(inputs)
});